import { useEffect, useMemo, useState } from 'react';
import { useMenuContext } from '../../context';
import BMTriggerButton from './BMTriggerButton';
import IoTMTriggerButton from './IoTMTriggerButton';

// Constants for button positioning
const BUTTON_SPACING = 40;
const IOTM_BUTTON_SPACING = 70;
const BASE_TOP_POSITION = 95;

type Props = {
  onBMOpen?: () => void;
  onIoTOpen?: () => void;
  onBMClose?: () => void;
  onIoTClose?: () => void;
  setMenuIsOpen: (menuIsOpen: boolean) => void;
  menuIsOpen: boolean;
  bmItems?: any[];
  handleSelectMenu?: (menu: any) => void;
  libraryIconsBaseUrl: string;
  awsIconUrl: string;
  selectedMenuId?: number;
};

export default function TriggerButtons({
  onBMOpen,
  onBMClose,
  onIoTClose,
  onIoTOpen,
  setMenuIsOpen,
  menuIsOpen,
  bmItems,
  handleSelectMenu,
  libraryIconsBaseUrl,
  awsIconUrl,
  selectedMenuId,
}: Props) {
  const { open } = useMenuContext();
  const [hasBeenOpened, setHasBeenOpened] = useState(false);

  const activeMenus = useMemo(() => bmItems?.filter((menu) => menu.active), [bmItems])?.sort((a, b) => a.order - b.order);

  useEffect(() => {
    if (open) {
      setHasBeenOpened(true);
    }
  }, [open]);

  return (
    <div id="bm-trigger-buttons" style={{ position: 'absolute' }}>
      {onBMOpen && (
        <>
          <div
            style={{
              position: 'absolute',
              top: `${BASE_TOP_POSITION}px`,
              left: 0,
              right: 0,
              minHeight: `${Math.max(7, activeMenus?.length || 0) * BUTTON_SPACING}px`,
              pointerEvents: 'none',
              zIndex: 0,
            }}
          />
          {activeMenus?.map((item, i, filteredArray) => {
            const topPosition = BASE_TOP_POSITION + i * BUTTON_SPACING;
            const isFirst = i === 0;
            const isLast = i === filteredArray.length - 1;
            return (
              <BMTriggerButton
                key={i}
                item={item}
                libraryIconsBaseUrl={libraryIconsBaseUrl}
                awsIconUrl={awsIconUrl}
                top={topPosition}
                index={i}
                isFirst={isFirst}
                isLast={isLast}
                onOpen={() => {
                  if (handleSelectMenu) {
                    handleSelectMenu(item);
                  }
                  onBMOpen();
                }}
                onClose={onBMClose}
                setMenuIsOpen={setMenuIsOpen}
                hasBeenOpened={hasBeenOpened}
                menuIsOpen={menuIsOpen}
                selectedMenuId={selectedMenuId}
              />
            );
          })}
        </>
      )}
      {onIoTOpen && (
        <IoTMTriggerButton
          onOpen={onIoTOpen}
          onClose={onIoTClose}
          setMenuIsOpen={setMenuIsOpen}
          hasBeenOpened={hasBeenOpened}
          menuIsOpen={menuIsOpen}
          top={
            onBMOpen && bmItems?.length
              ? BASE_TOP_POSITION + bmItems.length * IOTM_BUTTON_SPACING
              : BASE_TOP_POSITION
          }
        />
      )}
    </div>
  );
}
